/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum DiabetesType {
  No = 'no',
  Type1 = 'type1',
  Type2 = 'type2'
}
